export default __webpack_public_path__ + "static/media/product_9.9d138a9a.webp";